module.exports = __webpack_public_path__ + "static/img/product_banner_18_zh.2a790c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_18_zh.png
// module id = vAKM
// module chunks = 34